import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DevPortalSessionService } from './dev-portal-session.service';

function shouldAttachDevBearer(url: string): boolean {
  const base = environment.apiBaseUrl;
  if (base && url.startsWith(base)) {
    return true;
  }
  return url.includes('/api/');
}

export const devAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(DevPortalSessionService);

  if (!environment.auth.useLocalDevAuth) {
    return next(req);
  }

  const token = session.getToken();
  if (!token || !shouldAttachDevBearer(req.url)) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
